module.exports = __webpack_public_path__ + "static/media/plugin.5ba97e9b.svg";